import React, { useRef } from "react";
import GetAppIcon from "@material-ui/icons/GetApp";
import { useDispatch } from "react-redux";
import * as actions from "../../../../../../store/actions";
import { VideoInfo } from "../../models/videoInfo";
import { SegmentData, DeviceModel } from "../../../../Models/devices";

interface Props {
  buttonStyles: string;
  videoInfo: VideoInfo | null;
  serialNumber: string;
  device?: DeviceModel;
}

const DownloadButton = ({ buttonStyles, videoInfo, serialNumber, device }: Props) => {
  const dispatch = useDispatch();

  const parsePlaylist = (playlist: string) => {
    const regex = /#EXT-X-MAP:URI="(.*)"/;
    const segmentData: SegmentData[] = [];
    let modifiedPlaylist = playlist.split("\r\n");
    if (modifiedPlaylist.length === 1) {
      modifiedPlaylist = playlist.split("\n");
    }
    const localPlaylist = modifiedPlaylist
      .map((line: string) => {
        const match = regex.exec(line);
        if (match) {
          segmentData.push({ name: "init.mp4", url: match[1] });
          return '#EXT-X-MAP:URI="init.mp4"';
        }
        if (!line.startsWith("https")) {
          return line;
        }
        const splitSegment = line.split("/");
        const filename = splitSegment[splitSegment.length - 1].split("?")[0];
        const decodedFilename =
          decodeURIComponent(filename)
            .split(".")[0]
            .replaceAll("-", "")
            .replaceAll(":", "")
            .replaceAll("_", "") + ".m4s";
        segmentData.push({ name: decodedFilename, url: line });
        return decodedFilename;
      })
      .join("\n");
    return { localPlaylist, segmentData };
  };

  const getPlaylist = async (videoInfo: VideoInfo) => {
    const response = await fetch(videoInfo.url);
    const playlist = await response.text();
    return playlist;
  };

  const handleClick = async () => {
    if (!videoInfo) return;

    const playlist = await getPlaylist(videoInfo);

    // used in ViconDownloadVideoFromCloud.tsx.
    const data = parsePlaylist(playlist);

    const payload = {
      localPlaylist: data.localPlaylist,
      serialNumber,
      segmentData: data.segmentData,
      cameraName: device?.name || "",
    };

    dispatch(actions.viconDownloadVideoFromCloud(payload));
  };

  return (
    <button id="download" className={buttonStyles} type="button" onClick={handleClick}>
      <GetAppIcon />
    </button>
  );
};

export default DownloadButton;
